<div
  class="animate-pulse w-full h-full"
  [class.rounded]="type() === 'square'"
  [class.rounded-full]="type() === 'circle'"
></div>
